import Bear from "../assets/images/animals/Bear.png";
import Chicks from "../assets/images/animals/Chicks.png";
import Deer from "../assets/images/animals/Deer.jpg";
import Dog from "../assets/images/animals/Dog.png";
import Fox from "../assets/images/animals/Fox.jpg";
import Horse from "../assets/images/animals/Horse.png";
import Kitten from "../assets/images/animals/Kitten.jpg";
import KittenHug from "../assets/images/animals/KittenHug.png";
import Panther from "../assets/images/animals/Panther.png";
import Tiger from "../assets/images/animals/Tiger.jpg";
import WolfHowl from "../assets/images/animals/WolfHowl.png";

import Alligator from "../assets/images/Cartoon/Alligator.png";
import Bulbasaur from "../assets/images/Cartoon/Bulbasaur.png";
import Dora from "../assets/images/Cartoon/Dora.png";
import Grasshopper from "../assets/images/Cartoon/Grasshopper.png";
import Mickey from "../assets/images/Cartoon/Mickey.png";
import Pig from "../assets/images/Cartoon/Pig.png";
import Pikachu from "../assets/images/Cartoon/Pikachu.png";
import Simba from "../assets/images/Cartoon/Simba.png";
import SpongeBob from "../assets/images/Cartoon/SpongeBob.png";
import WinnieFriends from "../assets/images/Cartoon/WinnieFriends.png";

import Beach from "../assets/images/Holiday/Beach.png";
import BeachLandscape from "../assets/images/Holiday/BeachLandscape.png";
import CoconutDrink from "../assets/images/Holiday/CoconutDrink.png";
import Sunshine from "../assets/images/Holiday/Sunshine.png";
import SunSpikes from "../assets/images/Holiday/SunSpikes.png";

import Family from "../assets/images/Misc/Family.png";
import FamilySilhouette from "../assets/images/Misc/FamilySilhouette.png";
import LightsBig from "../assets/images/Misc/LightsBig.png";
import LightsSmall from "../assets/images/Misc/LightsSmall.png";
import LightsMed from "../assets/images/Misc/LightsMed.png";
import Rainbow from "../assets/images/Misc/Rainbow.png";

import ArtTree from "../assets/images/Nature/ArtTree.png";
import TreeGlow from "../assets/images/Nature/TreeGlow.png";
import TreeRocks from "../assets/images/Nature/TreeRocks.png";

import Angel from "../assets/images/Smiley/Angel.png";
import BlowKiss from "../assets/images/Smiley/BlowKiss.png";
import Kisses from "../assets/images/Smiley/Kisses.png";
import LoveHearts from "../assets/images/Smiley/LoveHearts.png";
import Sunglasses from "../assets/images/Smiley/Sunglasses.png";
import SunGrin from "../assets/images/Smiley/SunGrin.png";
import SunSmile from "../assets/images/Smiley/SunSmile.png";
import Wink from "../assets/images/Smiley/Wink.png";

import CantStop from "../assets/images/Text/CantStop.png";
import HappyBirthday from "../assets/images/Text/HappyBirthday.png";
import HappyHolidays from "../assets/images/Text/HappyHolidays.png";
import HappyNewYear from "../assets/images/Text/HappyNewYear.png";
import LoveBalloon from "../assets/images/Text/LoveBalloon.png";
import LoveBig from "../assets/images/Text/LoveBig.png";
import LoveBirds from "../assets/images/Text/LoveBirds.png";
import LoveBubble from "../assets/images/Text/LoveBubble.png";
import LoveCursive from "../assets/images/Text/LoveCursive.png";
import LoveFlower from "../assets/images/Text/LoveFlower.png";
import LoveHeart from "../assets/images/Text/LoveHeart.png";
import LoveHeartBalloon from "../assets/images/Text/LoveHeartBalloon.png";
import LoveStory from "../assets/images/Text/LoveStory.png";
import NeedLove from "../assets/images/Text/NeedLove.png";
import TrueLove from "../assets/images/Text/TrueLove.png";

import Boat from "../assets/images/Vehicles/Boat.png";
import Car from "../assets/images/Vehicles/Car.png";
import CarRed from "../assets/images/Vehicles/Car-Red.png";
import Rocket from "../assets/images/Vehicles/Rocket.png";
import Ship from "../assets/images/Vehicles/Ship.png";
import Spaceship from "../assets/images/Vehicles/Spaceship.png";
import UFO from "../assets/images/Vehicles/UFO.png";
import Yacht from "../assets/images/Vehicles/Yacht.png";

export const CarouselData = [
	{
		category: "animals",
		picture: [
			Bear,
			Chicks,
			Deer,
			Dog,
			Fox,
			Horse,
			Kitten,
			KittenHug,
			Panther,
			Tiger,
			WolfHowl,
		],
	},
	{
		category: "Cartoon",
		picture: [
			Alligator,
			Bulbasaur,
			Dora,
			Grasshopper,
			Mickey,
			Pig,
			Pikachu,
			Simba,
			SpongeBob,
			WinnieFriends,
		],
	},
	{
		category: "Holiday",
		picture: [Beach, BeachLandscape, CoconutDrink, Sunshine, SunSpikes],
	},
	{
		category: "Misc",
		picture: [
			Family,
			FamilySilhouette,
			LightsBig,
			LightsSmall,
			LightsMed,
			Rainbow,
		],
	},
	{
		category: "Nature",
		picture: [ArtTree, TreeGlow, TreeRocks],
	},
	{
		category: "Smiley",
		picture: [
			Angel,
			BlowKiss,
			Kisses,
			LoveHearts,
			Sunglasses,
			SunGrin,
			SunSmile,
			Wink,
		],
	},
	{
		category: "Text",
		picture: [
			CantStop,
			HappyBirthday,
			HappyHolidays,
			HappyNewYear,
			LoveBalloon,
			LoveBig,
			LoveBirds,
			LoveBubble,
			LoveCursive,
			LoveFlower,
			LoveHeart,
			LoveHeartBalloon,
			LoveStory,
			NeedLove,
			TrueLove,
		],
	},
	{
		category: "Vehicles",
		picture: [Boat, CarRed, Car, Rocket, Ship, Spaceship, UFO, Yacht],
	},
];

export default CarouselData;
